import { Box, Typography, Grid } from "@mui/material";
import { Container } from "@mui/system";
import { useNavigate } from "react-router-dom";

const PhilosophySection = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        py: 12,
        px: { xs: 2, md: 8 },
        background: "transparent", // ✅ important
        color: "#fff",
      }}
    >
      <Container maxWidth="lg">

        <Grid container spacing={6} alignItems="center">

          {/* LEFT SIDE */}
          <Grid item xs={12} md={6} textAlign="start">

            {/* HEADING */}
            <Typography
            variant="h3"
              sx={{

         
                fontWeight: 400,
                mb: 2,
                letterSpacing: "2px",
                color: "white",
              }}
            >
              OUR PHILOSOPHY
            </Typography>

            {/* DESCRIPTION */}
            <Typography
              sx={{
                color: "rgba(255,255,255,0.8)",
                lineHeight: 1.9,
                fontSize: "1rem",
                mb: 4,
                maxWidth: "520px",
              }}
            >
              Team Rajiv WILLIAMS helps Sales professionals & Sales teams across multiple industries.
              We strengthen your positioning, refine your communication strategy, and improve your cash flows
              through practical, market-tested engagement.
            </Typography>

            {/* LINK */}
            <Typography
             onClick={() => navigate("/about-us")}
              sx={{
                color: "#fff",
                fontWeight: 500,
                letterSpacing: "1px",
                cursor: "pointer",
                display: "inline-block",
                position: "relative",

                "&:after": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  bottom: -4,
                  width: "100%",
                  height: "1px",
                  background: "#0f63a5",
                },

                "&:hover": {
                  opacity: 0.8,
                },
              }}
            >
              Discover Our Full Story →
            </Typography>
          </Grid>

          {/* RIGHT SIDE */}
          {/* <Grid item xs={12} md={6}>
          <Box
            sx={{
              p: { xs: 3, md: 5 },
              borderRadius: "16px",

              // 🔥 GLASS CARD (like image)
              background: "rgba(255,255,255,0.05)",
              backdropFilter: "blur(8px)",

              border: "1px solid rgba(212,175,55,0.3)",

              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: { xs: "120px", md: "160px" },

              transition: "all 0.4s ease",

              "&:hover": {
                borderColor: "#d4af37",
                transform: "translateY(-4px)",
              },
            }}
          >
            <Typography
              sx={{
                color: "#d4af37",
                fontSize: { xs: "1rem", md: "1.2rem" },
                letterSpacing: "3px",
                textAlign: "center",
              }}
            >
              Practical • Tested • Executed
            </Typography>
          </Box>
        </Grid> */}
          <Grid item xs={12} md={6}>
  <Box
    sx={{
      p: 1,
      borderRadius: "16px",
      border: "1px solid rgba(212,175,55,0.3)",

      height: { xs: "160px", md: "450px" },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",

      overflow: "hidden",

      transition: "all 0.4s ease",

      "&:hover": {
        transform: "translateY(-4px)",
        borderColor: "#d4af37",
      },
    }}
  >
    {/* 🔥 IMAGE */}
    <Box
      component="img"
      src="https://dprstorage.b-cdn.net/RW/rwimage1.jpg" // 👉 change your image path
      alt="Luxury"
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        borderRadius: "12px",
      }}
    />
  </Box>
</Grid>
        </Grid>
      </Container>

    </Box>
  );
};

export default PhilosophySection;